import React, {FunctionComponent} from "react";

export const FilterSeparator: FunctionComponent<{}> = function FilterSeparator(props) {
    return <div className="update_filterSeparator">
        <div className="update_filterSeparatorSpacer"></div>
        <div className="update_filterSeparatorLeft"></div>
        <div className="update_filterSeparatorMid">AND</div>
        <div className="update_filterSeparatorRight"></div>
        <div className="update_filterSeparatorSpacer"></div>
    </div>
}